import { render, staticRenderFns } from "./LessonBlock.vue?vue&type=template&id=640094da&scoped=true&"
import script from "./LessonBlock.vue?vue&type=script&lang=js&"
export * from "./LessonBlock.vue?vue&type=script&lang=js&"
import style0 from "./LessonBlock.vue?vue&type=style&index=0&id=640094da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640094da",
  null
  
)

export default component.exports